import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import moment from 'moment'
import { 
   Table, Menu, Pagination, Input, Button, Segment,Header, Loader, Dropdown, Message
} from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from './ModalDetail';
import ModalEdit from './ModalEdit';
import swal from 'sweetalert'
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';


export default class BPSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests: true,
         activePage: 1,
         totalPages: 0,
         pageActive: 1,
         itemPerPage: 0,
         totalItem: 0,
         q: "",
         
         is_detail: false,
         data_detail: null,
         loading_detail: false,

         is_edit: false,
         data_edit: null,
         loading_edit: false,

         startDate: null,
         endDate: null,

      }

      this.handleSort = this.handleSort.bind(this);
      this.handlePaginationChange = this.handlePaginationChange.bind(this);
      this.searchBpSts = this.searchBpSts.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      this.filterBP = this.filterBP.bind(this);
      this.onRefreshData = this.onRefreshData.bind(this);
      
   }

   filterBP = () => {
      let { startDate, endDate } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      this.setState({requests: true})
      fetch(`${BaseURLDev}/bp?status=0&start=${start_date}&end=${end_date}`,{headers})
      .then(response => {
         if (!response.ok) {
            swal('Load data gagal',  { icon:'error' })
            this.setState({requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         console.log(resJSON)
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      })
      .catch(err => {
         swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
         icon: "error",
         });
         this.setState({requests:false});
      })
  }

   onOpenDetail = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_detail:true,
         data_detail:data[index],
         loading_detail:false
      });
   }

   onCloseDetail = () => {
      this.setState({
         is_detail:false,
         data_detail:null
      });
   }

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   onRefresh(){
      this.setState({ q: "", requests: true });
      this.onLoadData();
   }

   onLoadData(){
      fetch(`${BaseURLDev}/bp?status=0`,{headers})
      .then(response => {
         if (!response.ok) { 
            swal('Load data gagal',  { icon:'error' })
            this.setState({requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      })
      .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
              icon: "error",
            }); 
      });
   }

   componentWillMount = () => this.onLoadData();

   handlePaginationChange = (e, { activePage }) => {      
      if (this.state.pageActive === activePage){
         return false;
      }
      const { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      this.setState({ activePage, pageActive: activePage, requests: true })
      let url = null;
      if(this.state.q!==""){
         url = `${BaseURLDev}/bp?page=${activePage}&q=${this.state.q}&status=0&start=${start_date}&end=${end_date}`
      }else{
         url = `${BaseURLDev}/bp?page=${activePage}&status=0&start=${start_date}&end=${end_date}`         
      }
      fetch(url,{headers})
      .then(response => response.json())
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      });
   }

   onRefreshData = () => {
      this.setState({requests: true})
      fetch(`${BaseURLDev}/bp?status=0`,{headers})
      .then(response => {
          if (!response.ok) {
            swal('Load data gagal',  { icon:'error' })
            this.setState({requests:false});
            return Promise.reject(response.statusText);
          }
          return response.json();
      })
      .then(resJSON => {
        this.setState({
           data: resJSON.data,
           totalPages: resJSON.totalPage,
           requests: false,
           totalItem: resJSON.totalItem,
           itemPerPage: resJSON.itemPerPage,
           startDate: null,
           endDate: null,
           q: ''
        })
      })
      .catch(err => {
        swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
          icon: "error",
        });
        this.setState({requests:false});
      })
   }

   searchBpSts(e){
      this.setState({q:e.target.value, requests:false});
      fetch(`${BaseURLDev}/bp?q=${e.target.value}&status=0`,{headers})
      .then(response => response.json())
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      });
   }

   render() {
      const { column, data, direction,totalPages,activePage } = this.state;
     
      return (
         <div>
            <div>
               <Message
                  error
                  header='** Penting!'
                  content='Data yang tampil sebelum filter adalah data BP 3 hari terakhir.'
               />
               <Menu>
               <Menu.Item>
                     <DateRangePicker
                        hideKeyboardShortcutsPanel
                        reopenPickerOnClearDates
                        showClearDates
                        minimumNights={0}
                        withPortal
                        showDefaultInputIcon
                        displayFormat="DD/MM/YYYY"
                        small={true}
                        numberOfMonths={2}
                        startDatePlaceholderText="Awal"
                        endDatePlaceholderText="Akhir"
                        startDateId="startDateId"
                        endDateId="endDateId"
                        isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                        focusedInput={this.state.focusedInput}
                        onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                     />
                  </Menu.Item>
                  <Menu.Item>
                     <Dropdown text='Pilih Menu' icon='angle down' floating labeled button className='icon'>
                        <Dropdown.Menu>
                           <Dropdown.Item icon='filter' onClick={this.filterBP} disabled={(this.state.startDate===null && this.state.endDate===null) || this.state.requests} text='Filter data' />
                           <Dropdown.Item icon='refresh' onClick={this.onRefreshData} disabled={this.state.requests} text='Refresh' />
                        </Dropdown.Menu>
                     </Dropdown>
                  </Menu.Item>
                  <Menu.Item>
                     <Header>List data BP telah STS</Header>
                  </Menu.Item>
                  {/* <Menu.Item>
                    <Button.Group size='small'> */}
                        {/* <Button content="Filter" disabled={this.state.startDate===null && this.state.endDate===null} color='green' icon='filter' onClick={this.onFilter}/> */}
                        {/* <Button content="Export" disabled={this.state.requests} color='red' icon='download' onClick={this.onOpenExport} /> */}
                        {/* <Button color='blue' disabled={this.state.requests} content="Refresh" icon='refresh' onClick={this.onRefresh} />                        
                    </Button.Group>
                  </Menu.Item> */}
                  <Menu.Item position="right">
                     <Input type="text"
                        icon="search"
                        autoFocus 
                        value={this.state.q}
                        placeholder="Masukkan Nomor BP"
                        style={{width:'200px'}}
                        onChange={this.searchBpSts}
                         />
                  </Menu.Item>
               </Menu>
               <Segment loading={(this.state.requests || this.state.loading_edit || this.state.loading_detail)}>
                  <Table size='small' sortable celled>
                     <Table.Header fullWidth>
                          <Table.Row>
                            <Table.HeaderCell colSpan='7'>
                                <Pagination activePage={activePage} 
                                  onPageChange={this.handlePaginationChange} 
                                  totalPages={totalPages}
                                />
                            </Table.HeaderCell>
                          </Table.Row>
                        <Table.Row>
                           <Table.HeaderCell style={{width:"4%",textAlign:"center"}}>No.</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>#</Table.HeaderCell>
                           {/* <Table.HeaderCell style={{width:"15%"}}>OPD</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"15%"}}>SKPD</Table.HeaderCell> */}
                           <Table.HeaderCell style={{width:"10%"}} sorted={column === 'no_bukti' ? direction : null} onClick={this.handleSort('no_bukti')}>
                              Nomor
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"8%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                           Pembuatan
                           </Table.HeaderCell>
                           <Table.HeaderCell>Keterangan</Table.HeaderCell>                           
                        </Table.Row>
                     </Table.Header>
                     <Table.Body>
                        {data.length === 0 && 
                           <Table.Row>
                              <Table.Cell colSpan="4">Data tidak ditemukan</Table.Cell>                           
                           </Table.Row>
                        }
                        {_.map(data, (item,i) => (
                           <Table.Row key={i}> 
                              <Table.Cell>{i+1+(activePage-1)*this.state.itemPerPage}.</Table.Cell>                                                   
                              <Table.Cell style={{textAlign:"center"}}>
                                 <Button.Group size='mini'>
                                    <Button color='blue' 
                                       icon='block layout' 
                                       index={i}                                          
                                       onClick={this.onOpenDetail} 
                                    />
                                 </Button.Group>
                              </Table.Cell>
                              {/* <Table.Cell>{item.org_skpd.nama}</Table.Cell>
                              <Table.Cell>{item.org_opd.nama}</Table.Cell> */}
                              <Table.Cell>{item.no_bukti}</Table.Cell>
                              <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                              <Table.Cell>{item.uraian}</Table.Cell>
                           </Table.Row>
                        ))}
                     </Table.Body>
                     <Table.Footer fullWidth>
                        <Table.Row>
                           <Table.HeaderCell colSpan='8'>
                              <Pagination activePage={activePage} 
                                 onPageChange={this.handlePaginationChange} 
                                 totalPages={totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>
                  </Table>
               </Segment>
               {this.state.is_edit && 
                  <ModalEdit 
                     open={this.state.is_edit}
                     data_edit={this.state.data_edit} 
                     onClose={this.onCloseEdit} />
               }
               {this.state.is_detail && 
                  <ModalDetail 
                     open={this.state.is_detail}
                     data_detail={this.state.data_detail} 
                     onClose={this.onCloseDetail} />
               }
            </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/BPSTS.js